<template>
  <div class="p-3 text-left">
    <h2>{{ siteHeaderTitle }}</h2>
    <hr />
    <transition name="page" appear>
      <el-card class="mt-2">
        <table class="el-table el-table--striped el-tab">
          <thead>
            <tr>
              <th>Status</th>
              <th>ID</th>
              <th>{{ customerHeaderTitle }}</th>
              <th>Lieferdatum</th>
              <th>Produkt</th>
              <th>System</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td>
                <StatusTag :status="item.get('status')" />
              </td>
              <td>{{ item.get('or_id') || '-' }}</td>
              <td>{{ getUserName(item.get('user')) }}</td>
              <td>{{ getDate(item.get('deliveryDate')) }}</td>
              <td>
                <div v-html="getProducts(item.get('products'))"></div>
              </td>
              <td>
                <div v-html="getSystems(item.get('systems'))"></div>
              </td>
              <td>
                <el-tooltip class="item" effect="dark" content="Detail" placement="top-start">
                  <el-button type="info" circle @click="detailRequest(item)">
                    <i class="el-icon-zoom-in" />
                  </el-button>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </transition>
  </div>
</template>

<script>
import StatusTag from '../../components/atoms/StatusTag';
export default {
  name: 'OrderRequestView',
  components: { StatusTag },
  props: {
    table: String,
    checkUser: {
      type: Boolean,
      default: false,
    },
  },

  created() {},
  async mounted() {
    await this.onLoad();
  },
  destroyed() {},
  data() {
    return {
      items: [],
    };
  },
  computed: {
    isOrders() {
      return this.table === 'CartOrder';
    },
    customerHeaderTitle() {
      return this.isOrders ? this.$t('general.customer') : this.$t('general.interestedParty');
    },
    siteHeaderTitle() {
      return this.isOrders ? this.$t('general.orders') : this.$t('general.requests');
    },
    routeName() {
      if (this.$route.path.includes('admin'))
        return this.isOrders ? 'AdminOrderDetailPageRoute' : 'AdminRequestDetailPageRoute';
      else return this.isOrders ? 'OrderDetailPageRoute' : 'RequestDetailPageRoute';
    },
    canModify() {
      return !this.checkUser;
    },
  },
  methods: {
    async onLoad() {
      let query = new this.$parse.Query(this.table);
      if (this.checkUser) query.equalTo('user', this.$parse.User.current());
      query.limit(3000);
      query.addDescending('createdAt');
      query.includeAll();

      this.items = await query.find();
    },
    getDate(date) {
      let d = new Date(date);
      return d.toLocaleDateString(this.$locale);
    },
    getUserName(user) {
      return user.get('lastname') + ', ' + user.get('firstname') + '(' + user.get('company') + ')';
    },
    getProducts(products) {
      if (products.length === 1) return products[0].name;
      else if (products.length > 1) return products[0].name + '<b>...</b>';
    },
    getSystems(systems) {
      if (systems.length === 1) return systems[0].name;
      else if (systems.length > 1) return systems[0].name + '<b>...</b>';
    },
    detailRequest(item) {
      this.$router.push({ name: this.routeName, params: { id: item.id, canModify: this.canModify } });
    },
  },
};
</script>

<style scoped></style>
